module.exports = __webpack_public_path__ + "static/media/sub-weapon.51026247.png";